<template>
    <v-container grid-list-lg>
        <v-layout row wrap v-if="loadingCategories">
            <v-flex xs12 sm6 lg3 v-for="n in 3" :key="n">
                <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="category-products my-10 justify-center">
            <v-flex xs12 sm6 md3 lg3 v-for="product in allProducts" :key="product.id">
                <v-card class="text-center transparent">
                    <v-img
                            class="cursor-pointer"
                            :src="getProductImage(product.imageUrl)"
                            @click="$router.push('/product/' + product.alias)"
                    >
                    </v-img>
                    <v-card-text class="pt-0 px-0 text-center">
                        <h3 class="product-title my-2 mb-4 text-h5" @click="$router.push('/product/' + product.alias)">{{ product.name }}</h3>
                        <v-btn small color="secondary" depressed @click="addToCart({product: product, qty: 1})">
                            vložit do košíku
                            <v-icon right>mdi-cart-outline</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {getProductImage} from '../../Helper'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'Products',
        mixins: [getProductImage],
        computed: {
            ...mapGetters([
                'allProducts',
                'loadingCategories'
            ])
        },
        watch: {
            allProducts: function(newValue) {
                if (newValue) {
                    if (this.$gtm.enabled()) {
                        let products = [];

                        for (let i in this.allProducts) {
                            products.push({
                                id: this.allProducts[i].productId,
                                name: this.allProducts[i].name,
                                price: this.allProducts[i].amountWithVat,
                                category: this.allProducts[i].productCategoryName,
                                list: 'Home Page',
                                position: i + 1
                            })
                        }
                        this.$gtm.trackEvent({
                            event: 'productImpression', // Event type [default = 'interaction'] (Optional)
                            category: 'Ecommerce',
                            ecommerce: {
                                impressions: products
                            }
                        });
                    }
                }
            }
        },
        methods: {
            ...mapActions([
                'addToCart'
            ])
        }
    }
</script>

<style lang="scss">
    .category-products {
        .cart-button-wrapper {
            margin-top: -10px;
        }
        .cart-button {
            text-transform: initial;
        }
        .cursor-pointer {
            cursor: pointer;
        }
        .cart-image {
            width: 30px;
        }
        .price {
            strong {
                display: inline-flex;
                margin-top: 5px;
                font-size: 14px;
            }
        }
        .product-title {
            text-transform: uppercase;
            color: #2f1917;
        }
        .description {
            p {
                margin-bottom: 0 !important;
            }
        }
    }
</style>
